import api from './axiosInstance';
export const getClosingPriceTrend = (params) => api.get('/analytics/closing-price-trend', { params });
export const getAveragePriceTrend = (params) => api.get('/analytics/average-price-trend', { params });
